import { useQuery } from "@tanstack/react-query";
import { SocialPlatformsGetAPI } from "api";

const fetchData = () => {
  return SocialPlatformsGetAPI.get();
};
export const useFetchSocialMediaPlatforms = () => {
  return useQuery({
    queryKey: ["socialMediaPlatforms"],
    queryFn: fetchData,
  });
};
